import { Component, OnInit, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-customer-information-utf',
    templateUrl: './customer-information-utf.component.html',
    styleUrls: ['./customer-information-utf.component.scss'],
    standalone: false
})
export class CustomerInformationUtfComponent extends CfetBaseComponent implements OnInit {

  countDown: any;
  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = false;
  eligibilitystoredInfo: any;
  stepTwoIcon = true;
  stepTwoSelected = true;
  stepTwoInformationpage: boolean;
  stepTwoProfileDone: boolean;
  stepTwoDone = false;
  progressTrackerStatus: any = 'profileInfo';
  disableStep = true;
  showHeading = true;
  showEligibilitySection = true;
  showInfoSection = false;
  showStepCompleteHeading = false;
  signupCompleted = false;
  selectedWorkPlace: any;
  selectedAddress: any;
  selectedCity: any;
  selectedRole: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  divHeight1: number;
  divHeight2: number;
  openInactivityModal = '';
  showInactivityModal = true;
  openCancelModal = '';
  showCancelModal = false;
  checkTimeout = true;

  constructor(private title: Title,
    private elementRef: ElementRef,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.information.utfHtmlTitle);
    this.cfetService.isLandingPage.next(false);
    this.stepTwoInformationpage = true;
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.stepOneDone = true;
      this.disableStep = false;
      this.signupCompleted = true;
      this.eligibilitystoredInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedRole = this.eligibilitystoredInfo['selectedRole'];
      this.selectedAddress = this.eligibilitystoredInfo['eligibilityStatus'].selectedAddress;
      this.selectedWorkPlace = this.eligibilitystoredInfo['eligibilityStatus'].selectedName;
      this.selectedCity = this.eligibilitystoredInfo['eligibilityStatus'].selectedCity;
      this.selectedZipInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedZipInWorkplace;
      this.selectedStateInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedStateInWorkplace.split(':')[0];
    }
    if (environment.enableUTFSessionTimeout && this.checkTimeout) {
      this.checkInactivity();
    }
  }

  handleProgressTrackerEvent (event) {
    this.progressTrackerStatus = event;
    if (this.progressTrackerStatus === 'Activation') {
      this.stepTwoDone = true;
    }
  }

  goToInstantVerification1 (event) {
    if (event) {
      this.stepTwoProfileDone = true;
    }
  }

  clearSessionTimeout (event) {
    if (event) {
      clearInterval(this.countDown);
    }
  }
  closeInactivityModal (event) {
    if (event === 'modalClose') {
      this.openInactivityModal = 'close';
      clearInterval(this.countDown);
    }
  }

  setSessionTimeout (event) {
    this.checkTimeout = !event;
    clearInterval(this.countDown);
  }

  @HostListener('window:load')
  @HostListener('document:click')
  @HostListener('document:mousemove')
  @HostListener('window:scroll')
  @HostListener('document:keyup')
  @HostListener('document:touchstart', ['$event']) onMove ($event?: any) {
    if (environment.enableUTFSessionTimeout && this.checkTimeout && this.openInactivityModal !== 'open') {
      clearInterval(this.countDown);
      this.checkInactivity();
    }
  }

  cancelModal (event) {
    if (event) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  checkInactivity () {
    const countDownDate = new Date().getTime() + 600000;
    this.countDown = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;

      if (timeDiff < 0) {
        clearInterval(this.countDown);
        setTimeout(() => {
          this.openInactivityModal = 'close';
        });
        let returnUrl = '';
        if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
         returnUrl = sessionStorage.getItem('returnUrl');
        }
        const fnStatus = sessionStorage.getItem('fnStatus');
        sessionStorage.clear();
        if(returnUrl !== '') {
        sessionStorage.setItem('returnUrl',returnUrl);
        }
        sessionStorage.setItem('fnStatus',fnStatus);
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT_UTF;
      }
      if (timeDiff < 30000 && timeDiff > 0) {
        setTimeout(() => {
          this.openInactivityModal = 'open';
        });
        this.showCancelModal = false;
      }
      // Force the view to reflect the tick now rather than waiting on the next zone-triggered event.
      this.cdr.detectChanges();
    }, 350);
  }

}
